import { CalendarPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { ModalFooter } from "./ModalFooter"
import { ModalLogo } from "./ModalLogo"
import { PRIME_REACT_MODAL_DEFAULT_PROPS, STATE } from "./_constants"
import { StepOneModalProps } from "./_interfaces"

export function StepOneModal({
  firstConfirm,
  bankSelected,
  connectingData,
  setConnectingData,
  form,
  onStepOneConfirm,
  selectedDocumentType,
  setSelectedDocumentType,
  stepOneModalState,
  additionalMessage,
}: StepOneModalProps) {
  const [isModalVisible, setIsModalVisible] = stepOneModalState
  const verificationCode = firstConfirm[STATE.GET]?.additionalInfo?.otp
  const dropdownOptions =
    (bankSelected?.documenttype !== "0" &&
      bankSelected?.documenttype !== "" &&
      bankSelected?.documenttype?.split("|")) ??
    []

  const handleClose = (): void => {
    setIsModalVisible(false)
    firstConfirm[STATE.SET](undefined)
    form[STATE.SET]({})
    setSelectedDocumentType(null)
  }

  return (
    <PrimeReactModal
      ptContext={{
        dialog: PRIME_REACT_MODAL_DEFAULT_PROPS.dialog,
        calendar: PRIME_REACT_MODAL_DEFAULT_PROPS.calendar,
        dropdown: PRIME_REACT_MODAL_DEFAULT_PROPS.dropdown,
        inputtext: PRIME_REACT_MODAL_DEFAULT_PROPS.inputtext,
      }}
      className='tw-w-128 tw-max-w-full tw-h-fit tw-max-h-full tw-flex tw-flex-col tw-gap-2'
      onHide={handleClose}
      closeOnEscape
      visible={Boolean(isModalVisible)}
      focusOnShow={false}
      header='Vincular tarjeta'
      footer={
        <ModalFooter
          onCancel={handleClose}
          onConfirm={async () => {
            try {
              setConnectingData(true)
              await onStepOneConfirm?.({
                bankSelected,
                formData: {
                  ...form[STATE.GET],
                  service: bankSelected?.service ?? "",
                  ...(dropdownOptions
                    ? {
                        documenttype: selectedDocumentType ?? 0,
                      }
                    : {}),
                  ...(verificationCode
                    ? {
                        counterId: verificationCode?.counterId ?? "",
                        sessionId: verificationCode?.sessionId ?? "",
                      }
                    : {}),
                },
              })
              form[STATE.SET]((prevData) => ({
                ...prevData,
                ...(verificationCode
                  ? {
                      counterId: verificationCode?.counterId ?? "",
                      sessionId: verificationCode?.sessionId ?? "",
                    }
                  : {}),
              }))
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error("Error connecting bank", error)
            } finally {
              setConnectingData(false)
            }
          }}
          isButtonLoading={connectingData}
          confirmButtonProps={{
            disabled: Boolean(!form[STATE.GET]?.user || !form[STATE.GET]?.pass),
          }}
        />
      }
    >
      <ModalLogo bankSelected={bankSelected} />

      <>
        {bankSelected?.documenttype !== "" && dropdownOptions ? (
          <Dropdown
            value={dropdownOptions[Number(selectedDocumentType)]}
            options={dropdownOptions}
            onChange={(e) => {
              setSelectedDocumentType(
                dropdownOptions.findIndex((option) => option === e.value)
              )
            }}
            panelClassName='!tw-z-[1201]'
          />
        ) : bankSelected?.documenttype !== "0" ? (
          <div>{bankSelected?.documenttype}</div>
        ) : null}
        {bankSelected?.user &&
          bankSelected.user !== "0" &&
          bankSelected.user !== "" && (
            <InputText
              id='bankSelectedDataUser'
              autoComplete='new-password'
              autoFocus
              value={form[STATE.GET]?.user ? String(form[STATE.GET].user) : ""}
              placeholder={bankSelected.user}
              onChange={(e) =>
                form[STATE.SET]((prevData) => ({
                  ...prevData,
                  user: e.target.value,
                }))
              }
            />
          )}
        {bankSelected?.pass &&
          bankSelected.pass !== "0" &&
          bankSelected.pass !== "" && (
            <InputText
              id='bankSelectedDataPass'
              type='password'
              autoComplete='new-password'
              value={form[STATE.GET]?.pass ? String(form[STATE.GET].pass) : ""}
              placeholder={bankSelected.pass}
              onChange={(e) =>
                form[STATE.SET]((prevData) => ({
                  ...prevData,
                  pass: e.target.value,
                }))
              }
            />
          )}
        {bankSelected?.pass2 &&
        bankSelected?.pass2type === "date" &&
        bankSelected.pass2 !== "0" &&
        bankSelected.pass2 !== "" ? (
          <CalendarPrimeReact
            inputId='bankSelectedDataPass2Date'
            placeholder={bankSelected?.pass2}
            locale='es'
            selectionMode='single'
            dateFormat='dd/mm/yy'
            onChange={(e) =>
              form[STATE.SET]((prevData) => ({
                ...prevData,
                pass2: e.target?.value
                  ? new Intl.DateTimeFormat("es", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }).format(e.target.value)
                  : "",
              }))
            }
          />
        ) : bankSelected?.pass2 &&
          bankSelected.pass2 !== "0" &&
          bankSelected.pass2 !== "" ? (
          <InputText
            id='bankSelectedDataPass2'
            autoComplete='new-password'
            value={form[STATE.GET]?.pass2 ? String(form[STATE.GET].pass2) : ""}
            placeholder={bankSelected.pass2}
            onChange={(e) =>
              form[STATE.SET]((prevData) => ({
                ...prevData,
                pass2: e.target.value,
              }))
            }
          />
        ) : null}
        {bankSelected?.pass3 &&
        bankSelected.pass3 !== "0" &&
        bankSelected.pass3 !== "" ? (
          <InputText
            id='bankSelectedDataPass3'
            type='password'
            autoComplete='new-password'
            value={form[STATE.GET]?.pass3 ? String(form[STATE.GET].pass3) : ""}
            placeholder={bankSelected?.pass3}
            onChange={(e) =>
              form[STATE.SET]((prevData) => ({
                ...prevData,
                pass3: e.target.value,
              }))
            }
          />
        ) : null}

        {firstConfirm[STATE.GET]?.message && (
          <div className='tw-flex tw-gap-4 tw-bg-danger-10 tw-border tw-border-danger tw-text-danger tw-py-3 tw-px-4 tw-rounded'>
            <div className='tw-flex tw-flex-col'>
              <p className='tw-leading-5'>{firstConfirm[STATE.GET]?.message}</p>
            </div>
          </div>
        )}
        {additionalMessage && additionalMessage}
      </>
    </PrimeReactModal>
  )
}
